var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6536 0.431152C19.314 0.431152 24.7095 5.83953 24.7095 12.5C24.7095 19.1733 19.314 24.5689 12.6536 24.5689C5.98026 24.5689 0.584778 19.1733 0.584778 12.5C0.584778 5.83953 5.98026 0.431152 12.6536 0.431152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.6013 6.97979H15.693C17.0645 6.97979 18.1845 8.09983 18.1845 9.47136V15.5287C18.1845 16.9002 17.0645 18.0202 15.693 18.0202H9.6013C8.22987 18.0202 7.12125 16.9002 7.12125 15.5287V9.47136C7.12125 8.09983 8.22987 6.97979 9.6013 6.97979ZM12.63 10.1114H12.6643C13.9786 10.1114 15.0644 11.1971 15.0644 12.5001C15.0644 13.8372 13.9786 14.9229 12.6643 14.9229H12.63C11.3271 14.9229 10.2413 13.8372 10.2413 12.5001C10.2413 11.1971 11.3271 10.1114 12.63 10.1114ZM12.63 8.86562H12.6643C14.6415 8.86562 16.2987 10.5228 16.2987 12.5001C16.2987 14.5115 14.6415 16.1344 12.6643 16.1344H12.63C10.6527 16.1344 9.02982 14.5115 9.02982 12.5001C9.02982 10.5228 10.6527 8.86562 12.63 8.86562ZM16.2416 8.16844C16.6531 8.16844 17.0073 8.51127 17.0073 8.93413C17.0073 9.34557 16.6531 9.69992 16.2416 9.69992C15.7958 9.69992 15.4758 9.34557 15.4758 8.93413C15.4758 8.51127 15.7958 8.16844 16.2416 8.16844ZM9.57847 5.83691H15.7272C17.7045 5.83691 19.3274 7.45984 19.3274 9.43701V15.563C19.3274 17.5402 17.7045 19.1631 15.7272 19.1631H9.57847C7.6012 19.1631 5.96686 17.5402 5.96686 15.563V9.43701C5.96686 7.45984 7.6012 5.83691 9.57847 5.83691Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkInstagramIcon);
export default __webpack_public_path__ + "static/media/dark_instagram_icon.10b315f48400c6293a81b2a3ffea553e.svg";
export { ForwardRef as ReactComponent };